<template>
    <div>
        <!-- DIALOGO DE LOADING -->
        <Dialog :baseZIndex="2" :visible.sync="loading" :closable="false" :containerStyle="{ width: '300px' }" :modal="true">
            <ProgressBar mode="indeterminate" style="height: 0.5em" />
            <span>{{ loadingMensaje }}</span>
        </Dialog>

        <!-- EXCEL -->
        <Dialog :visible.sync="dialogExcel" :closable="false" :containerStyle="{ width: '600px' }" :modal="true">
            <Card>
                <template #title>
                    <div class="p-d-flex p-fluid grid formgrid">
                        <div class="text-left field col-4">
                            <Button icon="pi pi-times" class="p-button-rounded p-button-danger p-button-outlined"
                                @click="cerraExcel()" />
                        </div>
                        <div class="text-center field col-4">
                            Cargar Excel
                        </div>
                        <div class="text-right field col-4">
                            <Button icon="pi pi-file-pdf"
                                class="ml-3 mr-1 p-button-rounded p-button-success p-button-outlined"
                                @click="cargarExcel" />
                        </div>
                    </div>
                    <hr size=7 color="#FF6699">
                </template>
                <template #content>
                    <FileUpload name="demo[]" :customUpload="true" @uploader="cargarExcel" accept=".csv, .xlsx"
                        :maxFileSize="5242880">
                        <template #empty>
                            <p>Arrastre y suelte para cargar</p>
                        </template>
                    </FileUpload>
                </template>
            </Card>
        </Dialog>

        <div class="card">
            <div class="flex card-container blue-container overflow-hidden">
                <div class="flex-none flex align-items-center justify-content-center py-2">
                    <Button icon="pi pi-times" class="p-button-rounded p-button-danger p-button-outlined" @click="cierraVentana()" v-tooltip.right="'Cerrar'" />
                </div>
                <h1 class="flex-grow-1 flex align-items-center justify-content-center py-2">Nueva Nómina</h1>
                <div class="flex-none flex align-items-center justify-content-center py-2">
                    <Button icon="pi pi-download" class="p-button-rounded p-button-outlined" @click="abrirExcel()" v-tooltip.bottom="'Cargar Excel'" v-if="banderaCarga" style="color:#FBC31F"/>
                    <Button icon="pi pi-check-square" class="p-button-rounded p-button-outlined" @click="CargaNominaCompleto()" v-tooltip.bottom="'Validar'" v-if="banderaValida" style="color:#FF6C37"/>
                    <Button icon="pi pi-save" class="p-button-rounded p-button-outlined" @click="PostNomina()" v-tooltip.bottom="'Guardar Nómina'" v-if="banderaGuarda" style="color:#279846"/>
                </div>
            </div>
            <hr size=7 color="#FF6699">
        </div>
        <br>
        <div class="card">
            <TabView>
                <!-- CONCEPTOS -->
                <TabPanel header="Conceptos">
                    <NominaConceptos></NominaConceptos>
                </TabPanel>
                <!-- TRABAJADORES -->
                <TabPanel header="Trabajadores">
                    <NominaTrabajadores></NominaTrabajadores>
                </TabPanel>
                <!-- DATOS GENERALES -->
                <TabPanel header="Datos Generales">
                    <NominaGeneral></NominaGeneral>
                </TabPanel>
            </TabView>
        </div>
    </div>
</template>
<script>
    import axios from 'axios'
    import moment from 'moment'
    import NominaGeneral from './NominaGeneral.vue'
    import NominaTrabajadores from './NominaTrabajadores.vue'
    import NominaConceptos from './NominaConceptos.vue'
    import readXlsFile from 'read-excel-file';

    export default {
        components: {
            NominaGeneral,
            NominaTrabajadores,
            NominaConceptos,
        },
        data() {
            return {
                loading: false,
                loadingMensaje: '',
                dialogExcel: false,

                //A VER QUE PASA
                listRfc: [],
                listPT: [],
                listDT: [],
                listOT: [],
                listHT: [],

                //BANDERAS DE BOTONES
                banderaCarga: true,
                banderaValida: false,
                banderaGuarda: false,
            }
        },
        computed: {
            token() {
                return this.$store.state.usuario;
            },

            nomina(){
                return this.$store.state.nominaStore;
            },

            listEmisor() {
                return this.$store.state.listEmisorStore;
            },
            
            listReceptor() {
                return this.$store.state.listReceptorStore;
            },
            
            listNominaContaGo() {
                return this.$store.state.listNominaContaGoStore;
            },
            
            listComprobante() {
                return this.$store.state.listComprobanteStore;
            },

            tipoNomina(){
                return this.$store.state.tipoNominaStore;
            },

            tipoRegimen(){
                return this.$store.state.tipoRegimenStore;
            },
            
            periodicidadPago(){
                return this.$store.state.periodicidadPagoStore;
            },
            
            serie(){
                let serie_ = [];
                return serie_
            },
            
            listTrabajadores(){
                return this.$store.state.trabajadoresStore;
            },
            
            listPercepciones(){
                return this.$store.state.percepcionesStore;
            },
            
            listDeducciones(){
                return this.$store.state.deduccionesStore;
            },

            listOtrosPagos(){
                return this.$store.state.otrosPagosStore;
            },
            
            listTipoHoras(){
                return this.$store.state.tipoHorasStore;
            },
        
        },
        created() {
            this.Iniciales();
        },
        methods: {
            async Iniciales(){
                this.loading = true;
                await this.GetEmpresa();
                await this.GetTipoRegimen();
                await this.GetTipoNomina();
                await this.GeTPeriodicidadPago();
                await this.GetTrabajadores();
                await this.GetPercepciones();
                await this.GetDeducciones(),
                await this.GetOtrosPagos();
                await this.GetTipoHoras();
                this.loading = false;
            },

            async GetEmpresa() {
                try {
                    let response = await axios.get('Empresas/GetEmpresa/' + this.token.empresaBase);
                    if (response.data.idEmpresa != 0) {
                        this.$store.state.empresaStore = response.data
                    }
                } catch (error) {
                    console.log(error);
                }
            },
            
            async GetTipoRegimen(){
                try{
                    if(this.$store.state.tipoRegimenStore.length != 0){
                        return;
                    }
                    this.loadingMensaje = 'Consultando Percepciones...';
                    let respuesta = await axios.get("Nomina/GetTipoRegimen/");
                    let x =  respuesta.data
                    this.$store.state.tipoRegimenStore = x;
                }catch(error){
                    console.log(error);
                }
            },

            async GetTipoNomina(){
                try{
                    if(this.$store.state.tipoNominaStore.length != 0){
                        return;
                    }
                    this.loadingMensaje = 'Consultando Percepciones...';
                    let respuesta = await axios.get("Nomina/GetTipoNomina/");
                    let x =  respuesta.data
                    this.$store.state.tipoNominaStore = x;
                }catch(error){
                    console.log(error);
                }
            },

            async GeTPeriodicidadPago(){
                try{
                    if(this.$store.state.periodicidadPagoStore.length != 0){
                        return;
                    }
                    this.loadingMensaje = 'Consultando Periodicidad de Pago...';
                    let respuesta = await axios.get("Nomina/GetPeriodicidad/");
                    let x =  respuesta.data;
                    this.$store.state.periodicidadPagoStore = x;
                }catch(error){
                    console.log(error);
                }
            },

            async GetTrabajadores(){
                try{
                    this.loadingMensaje = 'Consultando Trabajadores...';
                    let respuesta = await axios.get("Nomina/GetTrabajadores/"+ this.token.empresaBase);
                    let x =  respuesta.data;
                    this.$store.state.trabajadoresStore = x;
                }catch(error){
                    console.log(error);
                }
            },

            async GetPercepciones(){
                try{
                    this.loadingMensaje = 'Consultando Percepciones...';
                    let respuesta = await axios.get("Nomina/GetPercepciones/" + this.token.empresaBase);
                    let x =  respuesta.data
                    this.$store.state.percepcionesStore = x;
                }catch(error){
                    console.log(error)
                }
            },

            async GetDeducciones(){
                try{
                    this.loadingMensaje = 'Consultando Deducciones...';
                    let respuesta = await axios.get("Nomina/GetDeducciones/" + this.token.empresaBase);
                    let x =  respuesta.data
                    this.$store.state.deduccionesStore = x;
                }catch(error){
                    console.log(error)
                }
            },

            async GetOtrosPagos(){
                try{
                    this.loadingMensaje = 'Consultando Otros Pagos';
                    let respuesta = await axios.get("Nomina/GetOtroPagos/" + this.token.empresaBase);
                    let x =  respuesta.data
                    this.$store.state.otrosPagosStore = x;
                }catch(error){
                    console.log(error)
                }
            },

            async GetTipoHoras(){
                try{
                    this.loadingMensaje = 'Consultando Otros Pagos';
                    let respuesta = await axios.get("Nomina/GetTipoHoras/");
                    let x =  respuesta.data
                    this.$store.state.tipoHorasStore = x;
                }catch(error){
                    console.log(error)
                }
            },
            
            async PostNomina(){
                this.loading = true;
                this.loadingMensaje = 'Guardando Nómina';
                let idNomina = await this.PostGeneral();
                await this.PostComprobante(idNomina);
                await this.PostNominaContaGo(idNomina);
                console.log(this.listNominaContaGo)
            },
            
            async PostGeneral(){
                console.log('Vamos a guardar los datos generales', this.nomina)
                try{
                    let respuesta = await axios.post("Nomina/PostNominaGeneral/" + this.token.empresaBase, this.nomina);
                    let x =  respuesta.data;
                    console.log(x);
                    return x;
                }catch(error){

                }
            },

            async PostComprobante(id){
                console.log('Vamos a guardar los comprobantes')
                try{
                    let respuesta = await axios.post("Nomina/PostNominaComprobantes/" + this.token.empresaBase + '/' + id, this.listComprobante);
                    let x =  respuesta.data;
                    console.log(x);
                    return x;
                }catch(error){
                    this.loading = false;
                    this.$toast.add({severity:'error', summary: 'Error', detail:'Error al guardar', life: 3000});
                }
                
            },

            async PostNominaContaGo(id){
                try{
                    let respuesta = await axios.post("Nomina/PostNominaCompleto/" + this.token.empresaBase + '/' + id, this.listNominaContaGo);
                    let x =  respuesta.data;
                    console.log(x);
                    this.cierraVentana();
                    this.loading = false;
                    return x;
                }catch(error){
                    console.log(error)
                    this.$toast.add({severity:'error', summary: 'Error', detail:'Error al guardar', life: 3000});
                    this.loading = false;
                }
            },

            cierraVentana(){
                this.$emit('closeDialogNuevaNomina')
            },
        
            //CARGA DESDE EXCEL
            abrirExcel() {
                if(this.nomina.descripcion === '' || !this.nomina.descripcion){
                    this.$toast.add({severity:'warn', summary: 'Descripción', detail:'Indique una descripción para continuar', life: 5000});
                    return;
                }

                if(!this.nomina.tipoRegimen){
                    this.$toast.add({severity:'warn', summary: 'Tipo de Régimen', detail:'Indique un tipo de régimen para continuar', life: 5000});
                    return;
                }

                if(this.nomina.noNomina === '' || !this.nomina.noNomina){
                    this.$toast.add({severity:'warn', summary: 'No. Nómina', detail:'Indique el número de nómina, puede indicar el valo "0"', life: 5000});
                    return;
                }

                if(!this.nomina.tipoNomina){
                    this.$toast.add({severity:'warn', summary: 'Tipo de Nómina', detail:'Indique un tipo de nómina para continuar', life: 5000});
                    return;
                }

                if(!this.nomina.periodicidadPago){
                    this.$toast.add({severity:'warn', summary: 'Periodicidad de pago', detail:'Indique la periodicidad de pago para continuar', life: 5000});
                    return;
                }

                if(!this.nomina.fechaPago){
                    this.$toast.add({severity:'warn', summary: 'Fecha de pago', detail:'Indique la fecha de pago para continuar', life: 5000});
                    return;
                }

                if(!this.nomina.fechaInicialPago){
                    this.$toast.add({severity:'warn', summary: 'Fecha inicial', detail:'Indique la fecha inicial para continuar', life: 5000});
                    return;
                }

                if(!this.nomina.fechaFinalPago){
                    this.$toast.add({severity:'warn', summary: 'Fecha final', detail:'Indique la fecha final para continuar', life: 5000});
                    return;
                }

                this.dialogExcel = true;
            },
            
            cerraExcel() {
                this.dialogExcel = false;
            },

            //SEPARAMOS Y CALCULAMOS LA NOMINA
            cargarExcel(event) {
                console.log('Paso 1')
                try {
                    let empresa = { ...this.$store.state.empresaStore }
                    this.$store.state.listEmisorStore = [];
                    this.$store.state.listReceptorStore = [];
                    this.listRfc = [];
                    this.listPT = [];
                    this.listDT = [];
                    this.listOT = [];
                    this.$store.state.listNominaContaGoStore = []

                    const file = event.files[0];
                    readXlsFile(file).then((rows) =>{
                        //DATOS GENERLAES
                        let x = 1
                        for(let i of rows){
                            try{
                                let rfc= rows[x][0]
                                let dias= rows[x][1]

                                //VALIDAMOS EL REGISTRO PATRONAL
                                let registroPatronal = '';
                                if(rows[x][2]){
                                    registroPatronal = rows[x][2]
                                }
                                
                                //VALIDAMOS EL RFC PATRON ORIGEN
                                let rfcPatronOrigen = ''
                                if(rows[x][3]){
                                    rfcPatronOrigen = rows[x][3]
                                }
        
                                this.datosEmisor(rfc, empresa.curp, registroPatronal, rfcPatronOrigen)
                                this.datosTrabajadores(rfc);
                                this.datosGenerales(rfc, dias);
                            }catch(error){

                            }
                            x++;
                        }
                    
                        //OBTENEMOS LAS PERCEPCIONES, DEDUCCIONES Y OTROS PAGOS
                        let conceptos_ = []
                        let longitud = rows[0].length
                        for (var c = 0; c < longitud; c++) {
                            let con = rows[0][c];
                            conceptos_.push(con)
                        }

                        //RECORREMOS LOS CONCEPTOS PARA AGREGRLOS A SU LISTA
                        let fil= rows.length;
                        let col= rows[0].length;
                        for (let i = 1; i < fil; i++) {
                            let rfc = rows[i][0]
                            for(let n = 4; n < longitud;){
                                let con_ = conceptos_[n]
                                let tipo = con_.split('|')[0]

                                //CASO DE LAS PERCEPCIONES
                                if(tipo === 'P'){
                                    let gravado = rows[i][n];
                                    n++;
                                    let exento = rows[i][n];
                                    //VALIDAMOS QUE TENGAN VALOR, SI NO LO TIENEN, PONEMOS 0
                                    if(!gravado){
                                        gravado = 0;
                                    }
                                    if(!exento){
                                        exento = 0
                                    }

                                    //HACEMOS EL REDONDEO
                                    gravado = Math.round(gravado *100)/100;
                                    exento = Math.round(exento*100)/100;
                                    this.datosPercepciones(rfc, con_, gravado, exento);
                                }

                                if(tipo === 'H'){
                                    let diasH = rows[i][n];
                                    n++;
                                    let tipoH = rows[i][n];
                                    n++;
                                    let horasH = rows[i][n];
                                    n++;
                                    let importeH = rows[i][n];
                                    if(diasH){
                                        this.datosHorasExtra(rfc, diasH, tipoH, horasH, importeH);
                                    }
                                }

                                if(tipo === 'D'){
                                    let importe = rows[i][n];
                                    //VALIDAMOS QUE TENGAN VALOR, SI NO LO TIENEN, PONEMOS 0
                                    if(!importe){
                                        importe = 0;
                                    }
                                    //HACEMOS EL REDONDEO
                                    importe = Math.round(importe *100)/100;

                                    this.datosDeducciones(rfc, con_, importe);
                                }

                                if(tipo === 'O'){
                                    let importe = rows[i][n];
                                    //VALIDAMOS QUE TENGAN VALOR, SI NO LO TIENEN, PONEMOS 0
                                    if(!importe){
                                        importe = 0;
                                    }
                                    //HACEMOS EL REDONDEO
                                    importe = Math.round(importe *100)/100;
                                    this.datosOtrosPagos(rfc, con_, importe);
                                }         
                                n++;
                            }
                        }
                        this.banderaValida = true;
                        this.banderaCarga = false;
                    })
                } catch (error) {
                    console.log(error)
                }
            },

            datosGenerales(itemRfc, itemDias){
                let general = {
                    rfc: itemRfc,
                    dias: itemDias,
                }
                this.listRfc.push(general);
            },

            datosEmisor(itemRfc, itemCurp, itemRP, itemRPO){
                try{
                    let emisor = {
                        curp: itemCurp,
                        registroPatronal: itemRP,
                        rfcPatronOrigen: itemRPO,
                        entidadSNCF: {
                            origenRecurso: '',
                            montoRecursoPropio: 0,
                        },
                        rfc: itemRfc,
                        folioFiscal: '0',
                    }
                    if(emisor.curp != '' || emisor.registroPatronal != '' || emisor.rfcPatronOrigen != ''){
                        this.$store.state.listEmisorStore.push(emisor);
                    }
                    emisor = {}
                }catch(error){
                    console.log(error)
                }
            },

            datosTrabajadores(item){
                try{
                    //BUSCAMOS EL TRABAJADOR
                    let indice = this.listTrabajadores.findIndex(x => x.rfc === item)
                    let ref = this.listTrabajadores[indice];
                    let fechaInicio = moment(ref.fechaInicioRelLaboral);
                    let fechaFinal = moment(this.nomina.fechaFinalPago)
                    let fechaPago = moment(this.nomina.fechaPago)
                    let antiguedad = fechaFinal.diff(fechaInicio, 'weeks');
    
                    let trabajador = {
                        curp: ref.curp,
                        numSeguridadSocial: ref.numSeguridadSocial,
                        fechaInicioRelLaboral: ref.fechaInicioRelLaboral,
                        antiguedad: 'P' + antiguedad + 'W',
                        tipoContrato: ref.tipoContrato,
                        sindicalizado: ref.sindicalizado,
                        tipoJornada: ref.tipoJornada,
                        tipoRegimen: this.nomina.tipoRegimen,
                        numEmpleado: ref.numEmpleado,
                        departamento: ref.departamento,
                        puesto: ref.puesto,
                        riesgoPuesto: ref.riesgoPuesto,
                        periodicidadPago: this.nomina.periodicidadPago,
                        banco: ref.banco,
                        cuentaBancaria: ref.cuentaBancaria,
                        salarioBaseCotApor: ref.salarioBaseCotApor,
                        salarioDiarioIntegrado: ref.salarioDiarioIntegrado,
                        claveEntFed: ref.claveEntFed,
                        rfc: ref.rfc,
                        folioFiscal: '0',
                        nombre : ref.nombre,
                        cp: ref.cp,
                    };
                    this.$store.state.listReceptorStore.push(trabajador);
                    trabajador = {}
                }catch(error){
                    
                }
            },
        
            datosPercepciones(itemRfc, itemConcepto, itemGravado, itemExento){
                //BUSCAMOS EL CONCEPTO
                try{
                    let id = itemConcepto.split('|')[1]
                    let indice = this.listPercepciones.findIndex(x => x.id == id)
                    let perpcepcion = { ...this.listPercepciones[indice] }
                    perpcepcion.folioFiscal = 0;
                    perpcepcion.importeGravado = itemGravado;
                    perpcepcion.importeExento = itemExento;
                    perpcepcion.rfc = itemRfc;
                    this.listPT.push(perpcepcion);
                    perpcepcion = {};
                }catch(error){
                    console.log(error)
                }
            },

            datosHorasExtra(itemRfc, itemDias, itemTipo, itemHoras, itemImporte){
                let objHoras = {
                    dias: itemDias,
                    tipoHoras: this.listTipoHoras.find(o => o.clave.includes(itemTipo)),
                    horasExtra: itemHoras,
                    importePagado: itemImporte,
                    rfc: itemRfc,
                    folioFiscal: 0,
                };
                this.listHT.push(objHoras);
            },

            datosDeducciones(itemRfc, itemConcepto, itemImporte){
                try{
                    let id = itemConcepto.split('|')[1]
                    let indice = this.listDeducciones.findIndex(x => x.id == id)
                    let deduccion = { ...this.listDeducciones[indice] }
                    deduccion.folioFiscal = 0;
                    deduccion.importe = itemImporte;
                    deduccion.rfc = itemRfc;
                    this.listDT.push(deduccion);
                    deduccion = {}
                }catch(error){

                }
            },

            datosOtrosPagos(itemRfc, itemConcepto, itemImporte){
                try{
                    let id = itemConcepto.split('|')[1]
                    let indice = this.listOtrosPagos.findIndex(x => x.id == id)
                    let otros = { ...this.listOtrosPagos[indice] }
                    otros.folioFiscal = 0;
                    otros.importe = itemImporte;
                    otros.rfc = itemRfc;
                    this.listOT.push(otros);
                    otros = {};
                }catch(error){

                }
            },
        
            //AGRUPAMOS Y ARMAMOS LA NOMINA
            async GeneraNominaContaGo(){
                console.log('Paso 2')
                try {
                    for(let n of this.listRfc){
                        //OBTENEMOS LAS PERCEPCIONES DEL TRABAJADOR
                        const per = this.listPT.filter(({ rfc }) => rfc === n.rfc);
                        const ded = this.listDT.filter(({ rfc }) => rfc === n.rfc);
                        const otr = this.listOT.filter(({ rfc }) => rfc === n.rfc);
                        const horas = this.listHT.filter(({ rfc }) => rfc === n.rfc);

                        let emisor = this.$store.state.listEmisorStore.find(({ rfc }) => rfc === n.rfc);
                        if(!emisor){
                            let emisorDefault = {
                                curp: '',
                                registroPatronal: '',
                                rfcPatronOrigen: '',
                                entidadSNCF: {
                                    origenRecurso: '',
                                    montoRecursoPropio: 0,
                                },
                                rfc: '',
                                folioFiscal: '0',
                            }
                            emisor = { ...emisorDefault }
                        }
                        let receptor = this.$store.state.listReceptorStore.find(({ rfc }) => rfc === n.rfc);

                        //TOTALES DE PERCEPCIONES, DEDUCCIONES Y OTROS PAGOS
                        let totalP = per.reduce((acumulador, actual) => acumulador + actual.importeGravado + actual.importeExento, 0);
                        let totalD = ded.reduce((acumulador, actual) => acumulador + actual.importe, 0);
                        let totalO = otr.reduce((acumulador, actual) => acumulador + actual.importe, 0);

                        //PERCEPCIONES
                        const separacion = per.filter(({ tipoPercepcion }) => tipoPercepcion.clave === '039' || tipoPercepcion.clave === '044');
                        const jubilacion = per.filter(({ tipoPercepcion }) => tipoPercepcion.clave === '023' || tipoPercepcion.clave === '025');

                        let sumGravado = per.reduce((acumulador, actual) => acumulador + actual.importeGravado, 0);
                        let sumExento = per.reduce((acumulador, actual) => acumulador + actual.importeExento, 0);
                        let sumSeparacion = separacion.reduce((acumulador, actual) => acumulador + actual.importeGravado + actual.importeExento, 0);
                        let sumJubilacion = jubilacion.reduce((acumulador, actual) => acumulador + actual.importeGravado + actual.importeExento, 0);
                        let sumSueldos = sumGravado + sumExento - sumSeparacion - sumJubilacion;

                        //HORAS EXTRA
                        let PercepcionHoras = per.find(o => o.tipoPercepcion.clave === '019');
                        if(PercepcionHoras){
                            PercepcionHoras.horasExtra = horas;
                            console.log(PercepcionHoras)
                        }

                        let nodoPercepcion = {
                            totalSueldos: sumSueldos,
                            totalSeparacionIndemnizacion: sumSeparacion, 
                            totalJubilacionPensionRetiro: sumJubilacion,
                            totalGravado: sumGravado,
                            totalExento: sumExento,
                            percepciones: per,
                            rfc: n.rfc,
                            folioFiscal: 0,
                        }

                        //DEDUCCIONES
                        const otrasDeducciones = ded.filter(({ tipoDeduccion }) => tipoDeduccion.clave != '002');
                        const impuestosretenidos = ded.filter(({ tipoDeduccion }) => tipoDeduccion.clave === '002');
                        let sumOtrasDeducciones = otrasDeducciones.reduce((acumulador, actual) => acumulador + actual.importe, 0);
                        let sumImpuestosRetenidos = impuestosretenidos.reduce((acumulador, actual) => acumulador + actual.importe, 0);

                        let nodoDeduccion = {
                            totalOtrasDeducciones: sumOtrasDeducciones,
                            totalImpuestosRetenidos: sumImpuestosRetenidos,
                            deducciones: ded,
                            rfc: n.rfc,
                            folioFiscal: 0,
                        }

                        //OTROS PAGOS
                        let nodoOtrosPagos = {
                            otroPagos: otr
                        }

                        let nominaContaGo = {
                            version: '1.2',
                            tipoNomina: this.nomina.tipoNomina,
                            fechaPago: this.nomina.fechaPago,
                            fechaInicialPago: this.nomina.fechaInicialPago,
                            fechaFinalPago: this.nomina.fechaFinalPago,
                            numDiasPagados: n.dias,
                            totalPercepciones: totalP,
                            totalDeducciones: totalD,
                            totalOtrosPagos: totalO,
                            emisor: emisor,
                            receptor: receptor,
                            percepciones: nodoPercepcion,
                            deducciones: nodoDeduccion,
                            otrosPagos: nodoOtrosPagos,
                            incapacidades: {},
                            rfc: n.rfc,
                            folioFiscal: 0,
                        }
                        this.$store.state.listNominaContaGoStore.push(nominaContaGo)
                    }

                } catch (error) {
                    console.log(error);
                }
                
            },

            async GeneraNominaComprobante(){
                console.log('Paso 3')
                let empresa = { ...this.$store.state.empresaStore };
                empresa.logo.base64 = '';
                empresa.notasVentasA = '';
                empresa.notasVentasB = '';

                this.$store.state.listComprobanteStore = [];
                for(let n of this.$store.state.listNominaContaGoStore){
                    let comprobante = {
                        idFactura: 0,
                        folioFiscal: '',
                        version: '4.0',
                        serie: this.nomina.serie,
                        folio: 0,
                        fecha: new Date(),
                        subTotal: n.totalPercepciones + n.totalOtrosPagos,
                        descuento: n.totalDeducciones,
                        moneda: {
                            id: 100,
                            clave: 'MXN',
                            descripcion: 'Peso Mexicano',
                            moneda: 'MXN | Peso Mexicano'
                        },
                        tipoCambio: 0,
                        total: n.totalPercepciones + n.totalOtrosPagos - n.totalDeducciones,
                        tipoComprobante: 'N',
                        tipoComprobanteInterno: 'Nomina',
                        metodoPago: {
                            "id": 1, 
                            "clave": "PUE", 
                            "metodoPago": "PUE | Pago en una sola exhibición", 
                            "descripcion": "Pago en una sola exhibición"
                        },
                        empresa: empresa,
                        cliente: {
                            rfc: n.receptor.rfc,
                            nombre: n.receptor.nombre,
                            cliente: '',
                            domicilioFiscal: n.receptor.cp,
                            regimenFiscal: {
                                "id": 3,
                                "clave": "605",
                                "moral": "No",
                                "fisica": "Sí",
                                "descripcion": "Sueldos y Salarios e Ingresos Asimilados a Salarios",
                                "regimenFiscal": "605 | Sueldos y Salarios e Ingresos Asimilados a Salarios"
                            },
                            usoCfdi: {
                                'id': 24, 
                                'clave': 'CN01', 
                                'moral': 'Sí', 
                                'fisica': 'No', 
                                'usoCfdi': 'CN01 | Nómina', 
                                'descripcion': 'Nómina'
                            },
                        },
                        rfc: n.receptor.rfc,
                        nombre: n.receptor.nombre,
                        atn: '',
                        notas: '',
                        estatus: 'Sin Timbrar',
                        estatusCancelacion: '',
                        usuarioCreador: '',
                        usuarioModificador: '',
                        usuarioAutoriza: '',
                        conceptos: [
                            {
                                idDocumento: 0,
                                folioFiscal: 0,
                                item: 0,
                                idConcepto: 0,
                                claveProdServ: {
                                    "id": 11026,
                                    "clave": "84111505",
                                    "descripcion": "Servicios de contabilidad de sueldos y salarios",
                                    "claveProdServ": "84111505 | Servicios de contabilidad de sueldos y salarios",
                                    "palabrasSimilares": ""
                                },
                                noIdentificacion: '',
                                cantidad: 1,
                                claveUnidad: {
                                    "id": 241, 
                                    "clave": "ACT", 
                                    "claveUnidad": "ACT | Actividad", 
                                    "descripcion": "Actividad"
                                },
                                unidad: '',
                                descripcion: 'Pago de nómina',
                                valorUnitario: n.totalPercepciones + n.totalOtrosPagos,
                                importe: n.totalPercepciones + n.totalOtrosPagos,
                                descuento: n.totalDeducciones,
                                precio: 0,
                                total: 0,
                                objImp: {
                                    "id": 3,
                                    "clave": "01",
                                    "objImp": "01 | No objeto de impuesto.",
                                    "descripcion": "No objeto de impuesto."
                                },
                                impuestos: {
                                    "traslados": [],
                                    "retenciones": []
                                },
                                numeroCuentaPredial: '',
                                material: '',
                                imagen: {
                                    base64: '',
                                },
                                linea: '',
                                marca: '',
                                submarca: '',
                                iepsGas: 0,
                                almacenable: '',
                                estatus: '',
                                usuarioCreador: '',
                                fechaCreacion: new Date(),
                                usuarioModificador: '',
                                fechaModificacion: new Date,
                                concepto: '',
                            }
                        ],
                        impuestos: {
                            traslados: [],
                            retenciones: [],
                        },
                        cfdiRelacionados: [
                            {
                            tipoRelacion: {},
                            cfdiRelacionados: [],
                            }
                        ],
                        timbreFiscalDigital: {
                            folioFiscal: '',
                            fechaTimbrado: new Date(),
                            selloCFDI: { base64: '' },
                            noCertificado: '',
                            noCertificadoSAT: '',
                            selloSAT: { base64: '' },
                            cadenaOriginal: '',
                            serie: '',
                            folio: '',
                            Error: '',
                            archivoXml: '',
                        },
                        remisiones: [],
                        protocolos: [],
                        ordenCompra: '',
                        ordenTrabajo: '',
                        portales: [], 
                    }
                    this.$store.state.listComprobanteStore.push(comprobante)
                }
                console.log(this.$store.state.listComprobanteStore)
                console.log(this.$store.state.listNominaContaGoStore)
            },
            
            async CargaNominaCompleto(){
                await this.GeneraNominaContaGo();
                await this.GeneraNominaComprobante();
                this.banderaValida = false;
                this.banderaCarga = false;
                this.banderaGuarda = true;
            },
        
        },
    }
    </script>
    <style>

    </style>